var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgText = function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#text_svg__a)",
    d: "M17.145 10.5h28.711a4.307 4.307 0 0 1 4.307 4.307v40.386a4.307 4.307 0 0 1-4.307 4.307h-28.71a4.307 4.307 0 0 1-4.307-4.307V14.807a4.307 4.307 0 0 1 4.306-4.307Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43 31.008H19.17a1.435 1.435 0 1 1 0-2.871H43a1.435 1.435 0 1 1 0 2.87ZM33.526 42.492H19.17a1.435 1.435 0 1 1 0-2.87h14.355a1.435 1.435 0 1 1 0 2.87ZM33.526 48.371H19.17a1.435 1.435 0 1 1 0-2.871h14.355a1.435 1.435 0 1 1 0 2.871ZM43 37H19.17a1.435 1.435 0 1 1 0-2.871H43A1.435 1.435 0 1 1 43 37Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "text_svg__a",
    x1: 31.501,
    x2: 31.501,
    y1: 10.5,
    y2: 59.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89BCF4"
  })))));
};
export default SvgText;